export default function AmericoCoverageLengths() {
  return [
    { label: "5 Year Term", value: "5" },
    { label: "7 Year Term", value: "7" },
    { label: "10 Year Term", value: "10" },
    { label: "15 Year Term", value: "15" },
    { label: "20 Year Term", value: "20" },
    { label: "25 Year Term", value: "25" },
    { label: "30 Year Term", value: "30" },
  ];
}

export function getTermLengthFromAge(age) {
  let termLength = 20;
  if (age >= 18 && age < 40) {
    termLength = 30;
  } else if (age >= 40 && age < 50) {
    termLength = 20;
  } else if (age >= 50 && age < 55) {
    termLength = 15;
  } else if (age >= 55) {
    termLength = 10;
  }
  return termLength;
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/CoverageLengths/AmericoCoverageLengths.js